import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper, UserImage } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import { MdDelete, MdEdit } from "react-icons/md";
import Tooltip from "../Tooltip";
import { capitalizeFirstLetter, getModeName, getRole, handleCopy } from "../../helpers";
import { IoCopySharp } from "react-icons/io5";
import moment from "moment";

const Table = ({
  apiData,
  setSelectedData,
  setIsDeleteCommissionModal,
  setIsEditCommissionModal,
  setIsPayCommissionModal,
  setIsEditExpense
}) => {
  const storageKey = `commission_expiring_page`;
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;
  const [currentPage, setCurrentPage] = useState(savedPage);

  useEffect(() => {
    setCurrentPage(savedPage);
  }, [savedPage]);

  const deleteCommission = (item) => {
    setIsDeleteCommissionModal(true);
    setSelectedData(item);
  };

  const editCommission = (item) => {
    setIsEditCommissionModal(true);
    setSelectedData(item);
  };

  const editExpense = (item) => {
    setIsEditExpense(true);
    setSelectedData(item);
  };

  const markAsPaid = (item) => {
    setIsPayCommissionModal(true);
    setSelectedData(item);
  };

  const ActionBtns = (item) => (
    <div className="flex items-center gap-3">
      {item.isPaid === 0 ?
        <Tooltip label="Click to edit">
          <button
            onClick={(e) => {
              e.stopPropagation();
              editCommission(item);
            }}
            className="text-gray-400 hover:text-blue-600 transition"
          >
            <MdEdit size={16} />
          </button>
        </Tooltip>
        :
        <Tooltip label="Click to edit">
          <button
            onClick={(e) => {
              e.stopPropagation();
              editExpense(item);
            }}
            className="text-gray-400 hover:text-blue-600 transition"
          >
            <MdEdit size={16} />
          </button>
        </Tooltip>}
      <Tooltip label="click to delete">
        <button
          onClick={() => deleteCommission(item)}
          // className="text-gray-400 hover:text-rose-600 transition"
          className="p-2 rounded-full hover:bg-gray-100 transition cursor-pointer"
        >
          <MdDelete className="text-gray-400 hover:text-rose-400" size={18} />
        </button>
      </Tooltip>
    </div>
  );

  const MarkAsPaidBtn = (item) => (
    <Tooltip label="Mark as paid">
      <button
        onClick={(e) => {
          e.stopPropagation();
          markAsPaid(item);
        }}
        className="
            text-sm px-3 py-1 rounded-full
            border border-gray-400 text-gray-500
            hover:bg-gray-100 hover:border-gray-500
            transition"
      >
        Mark as Paid
      </button>
    </Tooltip>
  );

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        property: getTenant(item),
        role: getRole(item.staffRole),
        amount: item.isPaid === 0 ? getAmountDue(item) : getAmountPaid(item),
        date: item.isPaid === 0 ? getDue(item) : getPaid(item),
        markAsPaid: item.isPaid === 0 ? MarkAsPaidBtn(item) : null,
        action: ActionBtns(item),
        mode: getPaymentModeX(getModeName(item.paymentMethod)),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);
  const getPaymentModeX = (mode) => {

    return (
      <div className="flex flex-col items-start gap-1">
        <div className="flex items-center gap-1">
          <span className="text-gray-600 text-sm">{mode}</span>
        </div>
      </div>
    );
  };
  const getName = (item) => {
    const name = capitalizeFirstLetter(item?.staffName);
    return (
      <UserImageWrapper >
        <div className="flex-row flex">
          <UserImage src={item.profilePicture ? item.profilePicture : Images.Avatar} alt={`Avatar for ${item.tenantName}`} />
        </div>
        <div className="flex flex-col gap-1 max-w-36">
          <span className="text-gray-600 text-sm font-medium line-clamp-2 block break-words overflow-hidden">
            {name}
          </span>
          <div className="flex gap-1">
            <span className="text-gray-400 text-xs">#{item.staffMobile}</span>
            <button onClick={(e) => {
              e.stopPropagation();
              handleCopy(item.staffMobile);
            }}>
              <IoCopySharp size={10} className="text-gray-400" />
            </button>
          </div>
        </div>
      </UserImageWrapper>
    );
  };

  const getTenant = (item) => (
    <div className="text-sm text-gray-600 space-y-1">
      <div className="flex items-center gap-2">
        <span >
          {capitalizeFirstLetter(item.tenantName)}
        </span>
      </div>

      <span className="text-xs text-gray-400">
        {item.propName}
      </span>
    </div>
  );

  const getAmountDue = (item) => {
    return <Amount>₹{item.balance}</Amount>
  };

  const getAmountPaid = (item) => {
    return <Amount>₹{item.amount}</Amount>
  };

  const getPaid = (item) => {
    return <span className="text-sm text-gray-600">{moment(item.paidDate).format("DD, MMM YY")}</span>
  };

  const getDue = (item) => {
    return <span className="text-sm text-gray-600">{moment(item.createdAt).format("DD, MMM YY")}</span>
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    const baseColumns = [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Tenant/Property",
        accessor: "property",
      },
    ];

    if (isMobileView) {
      return baseColumns;
    }
    const hasUnpaidItems = apiData?.some(item => item.isPaid === 0);
    const desktopColumns = [
      ...baseColumns,
      // {
      //   Header: "Role",
      //   accessor: "role",
      // },
      {
        Header: "Amount",
        accessor: "amount",
      },

    ];


    if (!hasUnpaidItems) {
      desktopColumns.push({
        Header: "Mode",
        accessor: "mode",
      });
    }

    desktopColumns.push({
      Header: "Date",
      accessor: "date",
    });
    if (hasUnpaidItems) {
      desktopColumns.push({
        Header: "Mark As Paid",
        accessor: "markAsPaid",
      });
    }
    if (hasUnpaidItems) {
      desktopColumns.push({
        Header: "",
        accessor: "action",
      });
    }
    return desktopColumns;
  }, [isMobileView, apiData]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex, storageKey]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Amount</strong>{" "}
                          {data[rowIndex].amount}
                        </li>
                        <li>
                          <strong>Role</strong>{" "}
                          {data[rowIndex].role}
                        </li>
                        <li>
                          <strong>Date</strong>{" "}
                          {data[rowIndex].date}
                        </li>
                        {data[rowIndex].markAsPaid && (
                          <li>
                            <strong>Status:</strong> {data[rowIndex].markAsPaid}
                          </li>
                        )}
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}

    </>
  );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`
  border-b
  hover:bg-slate-50
  transition
`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer w-full min-w-0`;
const Amount = tw.p`
  text-gray-800 
  text-sm 
  font-semibold 
  bg-neutral-100 
  px-3 
  py-1 
  rounded-full 
  inline-flex 
  min-w-[80px]
  justify-center
`;
export default Table;